module.exports = __webpack_public_path__ + "img/3U.a369977a.png";